import { GridColDef } from '@mui/x-data-grid-premium'

const listPrice: GridColDef = {
	field: 'standardPrice',
	headerName: 'List Price',
	width: 120,
	align: 'right',
	sortable: false,
	valueGetter: ( _value, row ) => {
		if ( !row.standardPrice?.amount ) return ''
		return new Intl.NumberFormat( 'en-US', {
			style: 'currency',
			currency: row.standardPrice.currencyCode ?? 'USD',
			maximumFractionDigits: 4,
			minimumFractionDigits: 2,
		} ).format( row.standardPrice.amount )
	},
}

export default listPrice